import styled from '@emotion/styled';

import { BRAND_COLORS, COLORS, LAYOUT } from 'styles/theme';

const ButtonAddCard = styled.div`
  cursor: pointer;

  padding: 1rem;
  border-radius: ${LAYOUT.BORDER_RADIUS * 2}px;
  border: 2px dashed ${COLORS.silver};
  background-color: ${COLORS.concrete};
  text-align: center;
  color: ${BRAND_COLORS.primary};
  transition: background-color 0.3s ease, border-color 0.3s ease;
  margin-bottom: 1rem;

  &:hover {
    background-color: ${COLORS.athensGray};
    border-color: ${BRAND_COLORS.accent};
  }

  > .icon {
    font-size: 3rem;
    margin-bottom: 0.5rem;
  }

  > .text {
    font-size: 0.9rem;
    letter-spacing: -0.2px;
  }
`;

export { ButtonAddCard };
